
import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { IAuthService } from '../services/IAuthService';
import { ToastContainer } from '../components/ToastContainer';
import { ToastMessage, ToastMessageType } from '../model/ToastMessage';

const Login = ({ authService }: Props) => {
  console.log('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [toastMessages, setToastMessages] = useState<ToastMessage[]>([]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const onLogin = async () => {
    try {
      await authService.login(email, password);
      if(searchParams.get('redirect')) {
        navigate(searchParams.get('redirect'));
      }
      else {
        navigate('/');
      }
    }
    catch(error) {
      console.log('error', error);
      setToastMessages([ { type: ToastMessageType.error, message: 'Invalid email or password', title: 'Error' } ]);
    }
  };

  return (
    <div className="container">
      <div className="card card-body mt-5 m-auto" style={{ maxWidth: 500 }}>
        <div>
          <input data-testid="login-email" type="email" className="form-control form-control-sm" placeholder="Email" onChange={e => setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" className="form-control form-control-sm mt-3" placeholder="Password" onChange={e => setPassword(e.target.value)} />
          <button data-testid="login-submit" className="btn btn-sm btn-primary mt-4" onClick={onLogin}>Login</button>
        </div>
      </div>
      <ToastContainer messages={toastMessages} />
    </div>
  );
}

interface Props {
  authService: IAuthService
}

export { Login };
